export const GET_ENCRYPTED_PSEUDONYMS_SUCCESS = 'GET_ENCRYPTED_PSEUDONYMS_SUCCESS';

export const getEncryptedPseudonymsSuccess = (careProviders, resultIds) => ({
    type: GET_ENCRYPTED_PSEUDONYMS_SUCCESS,
    payload: { careProviders, resultIds },
});
